import { render, staticRenderFns } from "./JilsterLogo.vue?vue&type=template&id=5845f198&scoped=true"
import script from "./JilsterLogo.vue?vue&type=script&lang=js"
export * from "./JilsterLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5845f198",
  null
  
)

export default component.exports